import { SaveButton } from '../../../../../common/button/save-button/SaveButton';
import Modal from '../../../../../common/modal/Modal';

import '../missed-visit-warning/MissedVisitWarning.css';

const AdjustVisitsWarning = ({ show, onKeepDateClick, onAdjustDateClick, onCancelClick }) => {
  if (!show) return null;

  return (
    <Modal headerTitle="Adjust next visit date?" justifyContent="center" contentPadding="5px 15px" hideButton>
      <p className="missed-visit-warning-message">
        The participant visited within the acceptable window period but not on the target date.
      </p>
      <p className="missed-visit-warning-message">Would you like to adjust the next visit date accordingly?</p>

      <div className="missed-visit-warning-buttons">
        <SaveButton
          textColor="#ffffff"
          border="1px solid #077187"
          title="Cancel"
          onClick={onCancelClick}
          color="#077187"
        />
        <SaveButton
          textColor="#077187"
          border="1px solid #077187"
          title="Keep Date"
          onClick={onKeepDateClick}
          color="#ffffff"
        />
        <SaveButton
          textColor="#ffffff"
          border="1px solid #077187"
          title="Adjust Date"
          onClick={onAdjustDateClick}
          color="#077187"
        />
      </div>
    </Modal>
  );
};

export default AdjustVisitsWarning;
